import React, { Component } from 'react';
import jwt_decode from "jwt-decode";
import Config from '../Config'
import { withMsal } from '@azure/msal-react';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state={
            mode:"",
            login:"",
            password:""
        }

    }

    componentDidMount() {
        // load data 
        console.log("Calling Microsoft to authenticate");

        setTimeout(function() { //Start the timer
            this.signIn();
        }.bind(this), 50)
    }

    login () {
        this.setState({loginInProgress:true, connectionError: false, loginFailed: false, accessDenied:false});

        const data = new FormData();
        data.append("login", this.state.login);
        data.append("password", this.state.password);
        
        const requestOptions = {
            method: 'POST',
            body: data
        };
        const url = Config.DigibonServiceBase + "auth";
        
        fetch(url, requestOptions)
          .then((res) => { return res.json(); })
          .then((json) => {
            if (json.token===null) {
                this.setState({ 
                    loginFailed: true,
                    loginInProgress:false
                })
            } else {
                const decoded = jwt_decode(json.token);
                if (Config.isDev) console.log("Token information",decoded);
                this.props.loginSuccess(json.token, decoded);
               
            }
          }).catch((error) => {
            this.setState({
                connectionError: true,
                loginInProgress:false
            });
          });
    }

    onFormSubmit = e => {
        e.preventDefault();
        
        this.login();
      }

    devLogin() {
        this.props.loginSuccess(Config.token, { name : "Allard DEV", office: "7835", role: ["IT"]});
    }

    
    handleChange(evt) {
        const name = evt.target.id;
        const value = evt.target.value;
        this.setState({ [name]: value });
    }

    signIn = () => {
        const { instance } = this.props.msalContext;
        
        console.log("Opening popup");
        instance.loginPopup()
          .then(response => {
            console.log('User signed in:', response);
            this.setState({loginInProgress:true, connectionError: false, loginFailed: false, accessDenied:false});

            const data = new FormData();
            data.append("token", response.accessToken);
            
            const requestOptions = {
                method: 'POST',
                body: data
            };
            const url = Config.DigibonServiceBase + "authWithToken";
            
            fetch(url, requestOptions)
              .then((res) => { return res.json(); })
              .then((json) => {
                if (json.token===null) {
                    console.log("Error: token is empty");
                    this.setState({ 
                        loginFailed: true,
                        loginInProgress:false
                    })
                } else {
                    const decoded = jwt_decode(json.token);
                    if (Config.isDev) console.log("Token information",decoded);
                    this.props.loginSuccess(json.token, decoded);
                   
                }
              }).catch((error) => {
                this.setState({
                    connectionError: true,
                    loginInProgress:false
                });
              });


          })
          .catch(error => {
            console.error(error);
          });
      };
    

    render() {
        return <div className="row">
            <div className="col"></div>
            <div className="col">
                <h4>Inloggen</h4>

                <button className="btn btn-secondary" onClick={this.signIn}>Sign In with Microsoft</button>
                
                {
                    this.state.loginInProgress && <div className="">
                        Even geduld...
                    </div>
                }

                {
                    this.state.loginFailed && <div className="text-danger">
                        Login niet gelukt. Controleer het wachtwoord en probeer nogmaals, of neem contact op met IT
                    </div>
                }
                {
                    this.state.accessDenied && <div className="text-danger">
                        Geen toegang tot de digibon, indien dit onjuist is neem contact op met IT
                    </div>
                }
                {
                    this.state.connectionError && <div className="text-danger">
                        Er is een probleem met de verbinding, probeer het later nogmaals, of neem contact op met IT
                    </div>
                }
                </div>
            <div className="col"></div>
        </div>


    }
}


export default withMsal(Login);